module.exports = __webpack_public_path__ + "img/metabase.2b58aedf.svg";